import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/joy";
import PropTypes from "prop-types";
import { ActivitiesFront } from "modules/activities";

const Activities = ({ style }) => {
	const { t } = useTranslation();

	return (
		<>
			<ActivitiesFront style={style} />
		</>
	);
};

export default Activities;
Activities.propTypes = {};
Activities.defaultProps = {};
